import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';

import { getInitials } from '../../utils/string.utils';
import { useSecureFileUrl } from '../hooks/use-secure-file-url';
import { getPublisherUrl } from '../../utils/utils';
import { ChannelOwner } from '../../shared/types';

import Link from 'components/ui/AppLink';

export interface ContributorProps {
    _id: string;
    name?: string;
    jobFunction?: string;
    className?: string;
    phone?: string;
}

export const Contributor = (props: ContributorProps) => {
    const { name = '', jobFunction = '', _id, phone = '' } = props;

    const imgLink = useSecureFileUrl(
        '/contributor-profile-picture/' + window.encodeURIComponent(_id)
    );

    const url = getPublisherUrl({ type: 'contributor' as ChannelOwner, _id });
    const initials = getInitials(name);

    if (!name) return null;

    return (
        <Box
            id={`article-page-contributor-${props.name}`}
            className={props.className}
            sx={{
                display: 'flex',
                minHeight: 64,
                height: '100%',
                backgroundColor: 'background.paper',
                p: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <Avatar sx={{ backgroundColor: 'primary.main' }} src={imgLink}>
                    {initials}
                </Avatar>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    ml: 2,
                }}
            >
                <Link to={url}>
                    <strong>{name}</strong>
                </Link>
                {(jobFunction || phone) && (
                    <div>
                        {jobFunction && (
                            <Typography
                                component="span"
                                variant="caption"
                                sx={{
                                    color: 'text.secondary',
                                    mt: 0.5,
                                    pr: 0.5,
                                }}
                            >
                                <strong>{jobFunction}</strong>
                            </Typography>
                        )}
                        {
                            // this trick is to force phone overflow correctly if both job and phone are long
                            phone && ' '
                        }
                        {phone && (
                            <Typography
                                component="span"
                                variant="caption"
                                sx={{
                                    color: 'text.secondary',
                                    mt: 0.5,
                                    pr: 0.5,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {phone}
                            </Typography>
                        )}
                    </div>
                )}
            </Box>
        </Box>
    );
};

export default Contributor;
